// extracted by mini-css-extract-plugin
export default {"heading":"heading_heading__bobyU","information_icon":"heading_information_icon__5uyJs"};